export const DataValidationRuleProp = Object.freeze({
    RuleType: 'ruleType',
    ErrorMessage: 'errorMessage',
    Precedence: 'precedence',
    CharactersCount: 'charactersCount',
    NotAllowedSymbolsRegex: 'notAllowedSymbolsRegex',
    CountOfDigitsAfterDecimalPoint: 'countOfDigitsAfterDecimalPoint',
    MinValue: 'minValue',
    MaxValue: 'maxValue',
});